import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Accordion } from 'react-bootstrap';
import { AppRemixIcon } from '@/layout/AppComponents';
import ReactDOMServer from 'react-dom/server';
import Sidebar from '../../../layout/Sidebar/Sidebar';
import AppLink from '../../../routing/helpers/AppLink';
import FilterSidebarBlock from '../../../layout/screenSpecifics/Modules/CorrectiveActions/Sidebar/FilterSidebarBlock';
import ReportSidebarBlock from '../../../layout/screenSpecifics/Modules/CorrectiveActions/Sidebar/ReportSidebarBlock';
import Translator from '../../../layout/components/helpers/Translator';

export default function CorrectiveActionsSidebar({ activeRoute }) {
  const { moduleBridgeHex, view } = useParams();
  const auth = useSelector((state) => state.auth);
  const permissions = useSelector(
    (s) => s.module[moduleBridgeHex]?.permissions?.correctiveActions
  );
  const userBridge = useSelector(
    (s) => s?.module?.[moduleBridgeHex]?.userBridge
  );

  return (
    <Sidebar>
      <img
        src={auth.user?.client?.logoUrl}
        className="img-fluid"
        alt={auth.user?.client?.name}
        title={auth.user?.client?.name}
      />
      <Accordion>
        <ul>
          {activeRoute === 'user_module_correctiveActions_task_list' && (
            <>
              <FilterSidebarBlock />
              {permissions?.reports &&
                Object.values(permissions?.reports).some((v) => v === true) && (
                  <ReportSidebarBlock />
                )}
            </>
          )}
          <li className="divider" />
          {(userBridge?.permissions?.level === 0 ||
            userBridge?.permissions?.taskCreation === true) && (
            <li
              className={`${
                activeRoute === 'user_module_correctiveActions_task_add'
                  ? 'active'
                  : ''
              }`}
            >
              <AppLink
                path="user_module_correctiveActions_task_add"
                params={{
                  moduleBridgeHex,
                }}
                className="p-0"
              >
                <span
                  className="sidebar-element"
                  title={ReactDOMServer.renderToString(
                    <Translator
                      file="module-correctiveActions"
                      name="module.ca.new-task"
                    />
                  )}
                >
                  <AppRemixIcon icon="add" className="sidebar-icon" />
                  <span className="sb-title">
                    <Translator
                      file="module-correctiveActions"
                      name="module.ca.new-task"
                    />
                  </span>
                </span>
              </AppLink>
            </li>
          )}
          <li
            className={`${
              activeRoute === 'user_module_correctiveActions_task_list' &&
              view === 'my-tasks'
                ? 'active'
                : ''
            }`}
          >
            <AppLink
              path="user_module_correctiveActions_task_list"
              params={{
                moduleBridgeHex,
                view: 'my-tasks',
                page: 1,
                filtersHex: 0,
              }}
              className="p-0"
            >
              <span
                className="sidebar-element"
                title={ReactDOMServer.renderToString(
                  <Translator
                    file="module-correctiveActions"
                    name="module.ca.my-ac"
                  />
                )}
              >
                <AppRemixIcon icon="home" className="sidebar-icon" />
                <span className="sb-title">
                  <Translator
                    file="module-correctiveActions"
                    name="module.ca.my-ac"
                  />
                </span>
              </span>
            </AppLink>
          </li>
          {Array.isArray(userBridge?.userPlants) &&
            userBridge?.userPlants.length > 0 && (
              <li
                className={`${
                  activeRoute === 'user_module_correctiveActions_task_list' &&
                  view === 'my-plants'
                    ? 'active'
                    : ''
                }`}
              >
                <AppLink
                  path="user_module_correctiveActions_task_list"
                  params={{
                    moduleBridgeHex,
                    view: 'my-plants',
                    page: 1,
                    filtersHex: 0,
                  }}
                  className="p-0"
                >
                  <span
                    className="sidebar-element"
                    title={ReactDOMServer.renderToString(
                      <Translator
                        file="module-correctiveActions"
                        name="module.ca.my-plants"
                      />
                    )}
                  >
                    <AppRemixIcon
                      icon="list-check"
                      className="sidebar-icon"
                      noVariants
                    />
                    <span className="sb-title">
                      <Translator
                        file="module-correctiveActions"
                        name="module.ca.my-plants"
                      />
                    </span>
                  </span>
                </AppLink>
              </li>
            )}
          {(userBridge?.permissions?.level === 0 ||
            userBridge?.permissions?.level === 2) && (
            <li
              className={`${
                activeRoute === 'user_module_correctiveActions_task_list' &&
                view === 'admin'
                  ? 'active'
                  : ''
              }`}
            >
              <AppLink
                path="user_module_correctiveActions_task_list"
                params={{
                  moduleBridgeHex,
                  view: 'admin',
                  page: 1,
                  filtersHex: 0,
                }}
                className="p-0"
              >
                <span
                  className="sidebar-element"
                  title={ReactDOMServer.renderToString(
                    <Translator
                      file="module-correctiveActions"
                      name="module.ca.manage-ca"
                    />
                  )}
                >
                  <AppRemixIcon
                    icon="list-check-2"
                    className="sidebar-icon"
                    noVariants
                  />
                  <span className="sb-title">
                    <Translator
                      file="module-correctiveActions"
                      name="module.ca.manage-ca"
                    />
                  </span>
                </span>
              </AppLink>
            </li>
          )}
        </ul>
      </Accordion>
    </Sidebar>
  );
}
